import React, {ReactElement} from 'react';
import {useDispatch} from 'react-redux';
import {IElementButton} from '../../../../incase-domain/elements/button';
import {jumpToSlideWithIdAction} from '../../../../store/actions/presentation.actions';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';

interface ElementButtonProps {
    element: IElementButton;
    device?: DeviceType;
    disabled?: boolean;
    showDisabledLoader?: boolean;
}

function ElementButton(props: ElementButtonProps): ReactElement {
    const {element, device = DeviceType.DESKTOP, disabled, showDisabledLoader} = props;
    const {icon, slideChange} = element;

    const dispatch = useDispatch();

    function renderIcon(): JSX.Element | null {
        if (icon) {
            return <img style={{width: `${icon.width}em`, height: `${icon.height}em`}} src={icon.src} alt="" />;
        }

        return null;
    }

    return (
        <button
            type="submit"
            disabled={disabled}
            style={getElementStyle(device, element)}
            className={`${getElementClasses(device)} ${disabled && showDisabledLoader && 'is-loading'}`}
            onClick={() => dispatch(jumpToSlideWithIdAction(slideChange.slideId, true))}
        >
            {element.text || 'Click me'}
            {renderIcon()}
        </button>
    );
}

function getElementStyle(device: DeviceType, element: IElementButton): React.CSSProperties {
    if (device === DeviceType.MOBILE) {
        return {
            background: element.color,
            color: element.font.color,
            fontFamily: element.fontFamily?.name,
        };
    }

    return {
        fontSize: `${element.font.size}em`,
        background: element.color,
        color: element.font.color,
        fontFamily: element.fontFamily?.name,
    };
}

function getElementClasses(device: DeviceType): string {
    if (device === DeviceType.MOBILE) {
        return 'c-buttonElement c-buttonElement--mobile';
    }

    return 'c-buttonElement';
}

export default ElementButton;
